import { Box } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Layout } from "../../components";
import { useAppDispatch } from "../../redux";
import { useLazyGetDataTableByIdQuery } from "../../redux/services";
import { closeBackdrop, openBackdrop } from "../../redux/slices/backdrop";
import { closeConfirmationDialog, openConfirmationDialog } from "../../redux/slices/confirmationDialog";
import { AppRoutes } from "../../router/routes";
import { CheckListData } from "../viewCheckList/viewCheckListDetail";
import { ViewParameterDetail } from "./viewParameterDetail";

function ViewInputParameterWithId() {
  const dispatch = useAppDispatch();
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [getInputParameterById, parameterResponse] = useLazyGetDataTableByIdQuery({
    refetchOnReconnect: true,
    refetchOnFocus: true,
  });

  const isEdit = id !== "New";

  const breadScrumName = React.useMemo((): string => {
    if (isEdit) {
      return parameterResponse.isLoading
        ? "..."
        : `${parameterResponse.data?.sequence_id ?? ""}`;
    } else {
      return "New";
    }
    // eslint-disable-next-line
  }, [parameterResponse.data]);

  const fetchDataTableList = async () => {
    if (isEdit) {
      dispatch(openBackdrop("Fetching Data Table Details..."));
      await getInputParameterById({
        dtTemplateType: "inputParameter",
        dtInstanceType: "template",
        dtTemplateId: id
      }).unwrap().catch((err: any) => {
        dispatch(closeBackdrop());
        if (err.status === 404) {
          dispatch(openConfirmationDialog({
            title: "404 - Not Found",
            body: "The Data Table you are looking for is either not available or you don't have permission to edit it",
            hideNegativeBtn: true,
            hideCloseIcon: true,
            positiveBtn: "Go Back",
            onOk: () => {
              dispatch(closeConfirmationDialog());
              navigate(-1);
            }
          }))
        } else {
          enqueueSnackbar(err.data?.title, { variant: "error" });
        }
      });
    }
  };

  React.useEffect(() => {
    fetchDataTableList();
    // eslint-disable-next-line
  }, [id]);

  return (
    (<Box
      sx={{
        p: 0.5,
        height: "100%"
      }}>
      <Layout
        currentPath={"Data Table Details"}
        history={[
          {
            label: "Document Templates",
            onClick: () => navigate(AppRoutes.viewTemplateList),
          },
          {
            label: "Data Table Templates",
            onClick: () => navigate(AppRoutes.technicalParametersList),
          },
          {
            label: breadScrumName,
            onClick: () => navigate(AppRoutes.viewTechnicalParametersWithId(id)),
          },
        ]}
        navBars={[]}
        mainPanel={
          <ViewParameterDetail
            parameterData={parameterResponse as CheckListData}
            isEdit={isEdit}
            refetch={fetchDataTableList}
          />
        }
        sideNavVariant={"whiteboard"}
        hideSideNavBar={false}
        otherBreadscrumProps={{         
          hideMenuBtn: true,
          showBackBtn: true,
        }}
      />
    </Box>)
  );
}

export default ViewInputParameterWithId;
